import Emitter from "es6-event-emitter";
import * as analyticsEvents from "./analyticsevents";

export default class AnalyticsManagerBase extends Emitter {
  constructor(options = {}, appAnalyticOptions = {}) {
    super();
    this._events = analyticsEvents;
    this._options = options;
    this.cmpManager = null;
    this._appAnalyticOptions = appAnalyticOptions;
  }

  handleEvent(eventType, appState) {
    // TODO handle some error handling on the event here
    this.trigger(eventType, appState);
  }

  /**
   * Returns a new, modified URL to be used when clicking on enrichments.
   *
   * This method should be overwritten in the `AnalyticsManager` of a client,
   * if such behaviour is required. The default implementation returns `undefined`,
   * resulting in no modifications to the URL.
   * @param {string} url the base URL.
   * @returns {string | undefined} a modified URL, or `undefined` if no modifications are required.
   */
  // eslint-disable-next-line no-unused-vars
  checkEnrichmentUrl(url) {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/analyticsmanagerbase.js